import { observer } from 'mobx-react';
import { CurrencyField } from '@roc/ui';
import { PortfolioInformationFormStore } from '../../../stores/portfolioInformation/portfolioInformationFormStore';


export const TotalPropertyAsIsValue = observer(({ store }: { store: PortfolioInformationFormStore }) => {
  return (
    <CurrencyField
      testId="totalEstimatedAsIsValue"
      disabled
      variant="outlined"
      standaloneLabel={false}
      label="Total Estimated As Is Value"
      value={store.totalEstimatedAsIsValue}
      fullWidth
    />
  );
});